import { render, staticRenderFns } from "./rulesSetting.vue?vue&type=template&id=1f3f56eb&scoped=true&"
import script from "./rulesSetting.vue?vue&type=script&lang=js&"
export * from "./rulesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f56eb",
  null
  
)

export default component.exports